(function () {
  function getPage() {
    return document.querySelector('[data-cart-page]');
  }

  function setBusy(busy) {
    const page = getPage();
    if (page) page.classList.toggle('is-busy', busy);
  }

  async function changeCart(body) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error('Cart update failed');
    return res.json();
  }

  async function updateCart(updates) {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates }),
    });
    if (!res.ok) throw new Error('Cart update failed');
    return res.json();
  }

  async function refreshSection() {
    const page = getPage();
    const sectionId = page?.dataset.sectionId;
    if (!sectionId) {
      window.location.reload();
      return;
    }
    const url = `${window.location.pathname}?sections=${sectionId}`;
    const res = await fetch(url);
    const data = await res.json();
    const html = data[sectionId];
    if (!html) {
      window.location.reload();
      return;
    }
    const wrap = document.getElementById(`shopify-section-${sectionId}`);
    if (!wrap) {
      window.location.reload();
      return;
    }
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.getElementById(`shopify-section-${sectionId}`);
    if (fresh) wrap.innerHTML = fresh.innerHTML;
    document.dispatchEvent(new CustomEvent('track50:cart:refresh'));
    initCartRecommendations();
  }

  async function applyCartUpdate(cart) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      if (cart.item_count > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
    if (window.Track50CartShipping) {
      window.Track50CartShipping.updateAll(cart);
    }
    if (window.Track50CartDiscount) {
      window.Track50CartDiscount.updateFromCart(cart);
    }
    await refreshSection();
    if (window.Track50CartShipping) {
      window.Track50CartShipping.updateAll(cart);
    }
    if (window.Track50CartDiscount) {
      window.Track50CartDiscount.fetchCart()
        .then((fresh) => window.Track50CartDiscount.updateFromCart(fresh))
        .catch(() => {});
    }
  }

  async function setQuantity(key, quantity) {
    setBusy(true);
    try {
      const cart = await changeCart({ id: key, quantity: Math.max(0, quantity) });
      await applyCartUpdate(cart);
    } catch (e) {
      window.location.reload();
    } finally {
      setBusy(false);
    }
  }

  async function clearCart() {
    const page = getPage();
    if (!page) return;
    const items = page.querySelectorAll('[data-cart-item-key]');
    if (!items.length) return;
    if (!window.confirm(page.dataset.strClearConfirm || 'Remove all items from your cart?')) return;
    setBusy(true);
    try {
      const updates = {};
      items.forEach((el) => {
        updates[el.dataset.cartItemKey] = 0;
      });
      const cart = await updateCart(updates);
      await applyCartUpdate(cart);
    } catch (e) {
      window.location.reload();
    } finally {
      setBusy(false);
    }
  }

  function initCartPageEvents() {
    if (document.documentElement.dataset.cartPageEvents === 'true') return;
    document.documentElement.dataset.cartPageEvents = 'true';

    document.addEventListener('click', (event) => {
      const page = event.target.closest('[data-cart-page]');
      if (!page) return;

      const qtyBtn = event.target.closest('[data-cart-qty]');
      if (qtyBtn) {
        event.preventDefault();
        const item = qtyBtn.closest('[data-cart-item]');
        if (!item) return;
        const key = item.dataset.cartItemKey;
        const valueEl = item.querySelector('[data-cart-qty-value]');
        let qty = parseInt(valueEl?.textContent, 10) || 0;
        if (qtyBtn.dataset.cartQty === 'up') qty += 1;
        else qty = Math.max(0, qty - 1);
        setQuantity(key, qty);
        return;
      }

      const removeBtn = event.target.closest('[data-cart-remove]');
      if (removeBtn) {
        event.preventDefault();
        const item = removeBtn.closest('[data-cart-item]');
        if (!item) return;
        setQuantity(item.dataset.cartItemKey, 0);
        return;
      }

      if (event.target.closest('[data-cart-clear]')) {
        event.preventDefault();
        clearCart();
      }
    });
  }

  async function initCartRecommendations() {
    const root = document.querySelector('[data-cart-rec]');
    if (!root) return;

    const body = root.querySelector('[data-cart-rec-body]');
    if (!body) return;

    const productId = root.dataset.productId;
    const collectionHandle = root.dataset.collectionHandle;
    const limit = parseInt(root.dataset.limit, 10) || 4;
    const intent = root.dataset.intent || 'related';
    const floatingAdd = root.dataset.floatingAdd !== 'false';
    const columns = root.dataset.columns || '4';
    const columnsMobile = root.dataset.columnsMobile || '2';

    let products = [];

    try {
      if (productId) {
        const res = await fetch(
          `/recommendations/products.json?product_id=${productId}&limit=${limit}&intent=${intent}`
        );
        if (res.ok) {
          const data = await res.json();
          products = data.products || [];
        }
      }
      if (!products.length && collectionHandle) {
        const res = await fetch(`/collections/${collectionHandle}/products.json?limit=${limit}`);
        if (res.ok) {
          const data = await res.json();
          products = data.products || [];
        }
      }
    } catch (e) {
      products = [];
    }

    if (!products.length || typeof window.buildThemeProductCard !== 'function') {
      root.hidden = true;
      return;
    }

    const gridHtml = products.map((p) => window.buildThemeProductCard(p, { floatingAdd })).join('');
    body.innerHTML = `<div class="cart-rec__grid product-rows__grid grid grid--${columns} grid--mobile-${columnsMobile}">${gridHtml}</div>`;
    root.hidden = false;
  }

  initCartPageEvents();
  initCartRecommendations();

  document.addEventListener('track50:cart:refresh', async () => {
    if (!getPage()) return;
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      if (window.Track50CartShipping) window.Track50CartShipping.updateAll(cart);
    } catch (e) {
      /* ignore */
    }
  });
})();
